import Button from "@/Components/Inputs/Button";
import { AddCircleIcon } from "@/Icons";

const PageTitleTemplate = ({
    title,
    cancelHandler,
    cancelLabel,
    confirmHandler,
    confirmLabel,
    isDataDirty,
    isCancelButtonDisabled,
    isConfirmButtonDisabled,
    addButtonClickHandler
}) => {
    const handleCancelClick = () => {
        if (cancelHandler && typeof cancelHandler === 'function') {
            cancelHandler('cancel');
        }
    };

    const handleConfirmClick = () => {
        if (confirmHandler && typeof cancelHandler === 'function') {
            confirmHandler('confirm');
        }
    };

    const handleAddButtonClick = () => {
        if(addButtonClickHandler && typeof addButtonClickHandler === 'function') {
            addButtonClickHandler();
        }
    }

    return (
        <div className="flex justify-between w-full h-10 mb-6">
            <div className="flex items-center justify-center gap-5">
                <div className="font-bold text-30 ">
                {title}
                </div>
                {addButtonClickHandler&& <Button startIcon={<AddCircleIcon/>} onClick={handleAddButtonClick}>
                    Add {title}
                </Button>}
            </div>
            {(cancelHandler || confirmHandler) && (
                <div className="flex gap-2.5">
                    {cancelHandler && <Button disabled={!isDataDirty || isCancelButtonDisabled} onClick={handleCancelClick} flat>{cancelLabel || 'Cancel'}</Button>}
                    {confirmHandler && <Button disabled={!isDataDirty || isConfirmButtonDisabled} onClick={handleConfirmClick}>{confirmLabel || 'Save'}</Button>}
                </div>
            )}
        </div>
    )
};

export default PageTitleTemplate;
